export default __webpack_public_path__ + "static/media/icons8-music-robot-94.cee1e951.png";